<div class="bgwhite">
  <div class="breadcrumbs hotel_banner bgwhite" style="padding-top: 80px;">
    <div class="container">
      <div class="text-left breadcrumbs-item bgwhite">
        <h2><span>Terms &</span> Conditions</h2>
        <div style="content: '';display: block;width: 100px;height: 3px; background: #06608c;border-radius: 25%;margin-top: 15px;margin-bottom: 5px;">
        </div>
      </div>
    </div>
  </div>


  <div class="main-body pri-body bgwhite">
    <div class="container p-inner">
      <p>The Website Owner, including subsidiaries and affiliates (“Website” or “Website Owner” or “we” or “us” or“our”)
        provides the information contained on the website or any of the pages comprising the website (“website”) to
        visitors (“visitors”) (cumulatively referred to as “you” or “your” hereinafter) subject to the terms and
        conditions set out in these website terms and conditions, the privacy policy and any other relevant terms and
        conditions, policies and notices which may be applicable to a specific section or module of the website.</p>
      <div class="cws_divider mb-25"></div>
      <p>
        Welcome to our website. If you continue to browse and use this website you are agreeing to comply with and be
        bound by the following terms and conditions of use, which together with our privacy policy govern {{companysname}}
        relationship with you in relation to this website.
      </p>

      <h2 class="title-section">
        <span class="">The use of this </span>website is subject to the following terms of use:
      </h2>
      <div class="cws_divider mb-25"></div>

      <ul class="term-ul bgwhite" style="padding-bottom: 30px">
        <li>
          <p>The content of the pages of this website is for your general information and use only. It is subject to
            change without notice.</p>
        </li>
        <li>
          <p>Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness,
            performance, completeness or suitability of the information and materials found or offered on this website
            for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors
            and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by
            law.
          </p>
        </li>
        <li>
          <p>Your use of any information or materials on this website is entirely at your own risk, for which we shall
            not be liable. It shall be your own responsibility to ensure that any products, services or information available
            through this website meet your specific requirements.</p>
        </li>
        <li>
          <p>This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance
            with the copyright notice, which forms part of these terms and conditions.</p>
        </li>
        <li>
          <p>All trade marks reproduced in this website which are not the property of, or licensed to, the operator are
            acknowledged on the website.</p>
        </li>
        <li>
          <p>Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offence.</p>
        </li>
        <li>
          <p>From time to time this website may also include links to other websites. These links are provided for your
            convenience to provide further information. They do not signify that we endorse the website(s). We have no
            responsibility for the content of the linked website(s).</p>
        </li>
        <li>
          <p>You may not create a link to this website from another website or document without [business name]'s prior
            written consent.</p>
        </li>
        <li>
          <p>Your use of this website and any dispute arising out of such use of the website is subject to the laws of
            India or other regulatory authority.</p>
        </li>
      </ul>

    </div>
  </div>
</div>
